// extracted by mini-css-extract-plugin
export default {"authLayout":"AuthSidebar_authLayout__Bv5GK","authSidebarLeft":"AuthSidebar_authSidebarLeft__opEEN","circles":"AuthSidebar_circles__W0FH9"};